module.exports = __webpack_public_path__ + "fonts/020c97dc8e0463259c2f9df929bb0c69.woff2";